//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE } from '@/scripts/constants/media-query'
import { mapGetters } from 'vuex'
export default {
  name: 'rb-rox-measure-pipillary-distance',
  computed: {
    ...mapGetters(['translation']),
    isMobile() {
      return this.$mq === MOBILE
    },
  },
}
